import { gql } from "@apollo/client";

export const GUEST_SIGN_UP = gql`
  mutation signupGuest(
    $phone: String!
    $email: String!
    $orgName: String!
    $assetId: String!
    $name: String!
    $firstName: String!
    $lastName: String!
  ) {
    signUpGuest(
      phoneNo: $phone
      email: $email
      organizationName: $orgName
      assetId: $assetId
      firstName: $firstName
      name: $name
      lastName: $lastName
    ) {
      token
      user {
        id
        name
        firstName
        lastName
        name
        displayName
        profile_pic
        phoneno
        dob
        isActive
        isEmailVarified
        isUserVerified
        isDeleted
        isForceResetPassword
        email
        roles {
          id
          key
        }
        userOrg {
          isIndividual
          isDeleted
          organization {
            id
            name
            leagalName
            phoneNo
            pin
            email
            isSeller
          }
        }
      }
    }
  }
`;

export const SIGNUP_NORMAL = gql`
  mutation signupNormal(
    $name: String!
    $email: String!
    $password: String!
    $phoneno: String!
    $organizationName: String
    $organizationId: String
  ) {
    signUpForNormalUser(
      name: $name
      email: $email
      password: $password
      phoneno: $phoneno
      organizationId: $organizationId
      organizationName: $organizationName
    ) {
      token
      user {
        id
        firstName
        lastName
        name
        displayName
        profile_pic
        phoneno
        dob
        isActive
        isEmailVarified
        isUserVerified
        isDeleted
        isForceResetPassword
        email
        roles {
          id
          key
        }
        userOrg {
          isIndividual
          isDeleted
          organization {
            id
            name
            leagalName
            phoneNo
            pin
            email
            isSeller
          }
        }
        currentOrganization {
          id
          name
          email
          leagalName
          phoneNo
          website
          sellerFee
          offerThreshold
        }
      }
    }
  }
`;

export const UPDATE_NORMAL_USER = gql`
  mutation updateNormalUser(
    $name: String!
    $email: String!
    $password: String!
    $phoneno: String!
    $organizationName: String
    $organizationId: String
  ) {
    updateNormalUser(
      name: $name
      email: $email
      password: $password
      phoneno: $phoneno
      organizationId: $organizationId
      organizationName: $organizationName
    ) {
      id
      firstName
      lastName
      name
      displayName
      profile_pic
      phoneno
      dob
      isActive
      isEmailVarified
      isDeleted
      isUserVerified
      isForceResetPassword
      email
      roles {
        id
        key
      }
      currentOrganization {
        id
        name
        email
        leagalName
        phoneNo
        website
        sellerFee
        offerThreshold
      }
    }
  }
`;

export const SIGNUP_PARTICIPANTS = gql`
  mutation signUpParticipant(
    $name: String!
    $email: String!
    $password: String!
    $phoneno: String
    $organizationName: String
    $organizationId: String
  ) {
    signUpParticipant(
      name: $name
      email: $email
      password: $password
      phoneNo: $phoneno
      organizationId: $organizationId
      organizationName: $organizationName
    ) {
      token
      user {
        id
        firstName
        lastName
        name
        displayName
        profile_pic
        phoneno
        dob
        isActive
        isEmailVarified
        isUserVerified
        isDeleted
        isForceResetPassword
        email
        roles {
          id
          key
        }
        userOrg {
          isIndividual
          isDeleted
          organization {
            id
            name
            leagalName
            phoneNo
            pin
            email
            isSeller
          }
        }
        currentOrganization {
          id
          name
          email
          leagalName
          phoneNo
          website
          sellerFee
          offerThreshold
        }
      }
    }
  }
`;
